import styled from "styled-components";
import { Link } from "react-router-dom";
import { tablet } from "styles/breakpoints";
import { defaultTheme } from "storybook/themes/default";

export const MainContainer = styled.div`
  padding: 25px;

  > div {
    margin-top: 38px;
  }
`;

export const LinkWrapper = styled.div`
  color: #00639b;
`;

export const SettingsLink = styled(Link)`
  padding: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cac4d0;
  text-decoration: none;
  color: inherit;
  font-weight: 500;
`;

export const MainWrapper = styled.div`
  padding: 25px;
`;

export const FormContainer = styled.div`
  > * {
    margin-bottom: 32px;
  }
`;

export const IsSubmittingWrapper = styled.div`
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    width: 20px !important;
    height: 20px !important;
  }

  svg {
    transform: scale(1.3);
  }
`;

export const ErrorWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 21px;
  gap: 24px;

  && {
    > div {
      display: flex;
      gap: 24px;
    }

    > button {
      color: #48495c;
      font-weight: 700;
      border-color: #0000006b;
    }
  }

  @media (max-width: ${tablet}px) {
    flex-direction: column;
  }
`;

export const LanguageDescriptionWrapper = styled.div`
  margin-top: 1rem;
`;

export const LoadingWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const InputHelperContainer = styled.div`
  padding-bottom: 9px;
`;

export const InputHelperText = styled.p`
  margin-bottom: 6px;
  line-height: 1.5;
  color: ${defaultTheme.colors.ciqBrandDark};
  font-size: 0.875rem;
  font-weight: 400;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${defaultTheme.colors.ciqBrand};
  }
`;
